export default "__VITE_ASSET__UdHNGUuJ__"